


























































































import { Component, Vue } from 'vue-property-decorator';
import { stringToByte } from '@/models/Utils';
import constants from '@/utils/constants';
interface FileEntity {
  code: string;
  status: string;
  filename: string;
}
@Component
export default class MenuBatchUpload extends Vue {
  public pageTitle: string = 'Upload Menu';
  public $swal: any;
  public uploading: boolean = false;
  public files: any[] = [];
  public filesInfo: any[] = [];
  public illegalImg: any[] = [];
  public filesSize: any = '2048 KB';
  public showSuccess: boolean = false;
  public showFailed: boolean = false;
  public errorList = [];
  public isUploading = false;
  get items(): FileEntity[] {
    return this.files.map(v => {
      return {
        code:
          String(v.name)
            .split('.')
            .shift() || '',
        status: '',
        filename: v.name
      };
    });
  }

  mounted() {
    this.uploading = false;
  }

  formatNames(files) {
    if (files.length < 3) {
      return files.map(v => v.name).join(', ');
    } else {
      const filename = files
        .slice(0, 3)
        .map(v => v.name)
        .join(', ');
      return `${filename} and ${files.length - 3} files selected`;
    }
  }

  resetAll() {
    this.files = [];
    this.filesInfo = [];
    this.showSuccess = false;
    this.showFailed = false;
  }

  async uploadAll() {
    this.filesInfo = [];
    let illegalFile: any = [];
    this.isUploading = true;
    this.files.map(v => {
      this.filesInfo.push({
        name: v.name,
        size: v.size
      });
    });
    this.filesInfo.map(v => {
      if (v.size > stringToByte(this.filesSize)) {
        illegalFile.push(v.name);
      }
    });
    if (illegalFile.length !== 0) {
      this.$swal(
        'The maximum size of the file should be 2MB!',
        `${illegalFile.join(
          ' , '
        )} is oversized, please compress and upload again.`,
        constants.STATUS_ERROR
      );
    } else {
      this.$store
        .dispatch('menuUploadAction', { web: true, file: this.files[0] })
        .then(res => {
          this.isUploading = false;
          if (res.status === constants.STATUS_200) {
            this.showSuccess = true;
            this.showFailed = false;
          } else {
            this.showSuccess = false;
            this.showFailed = true;
            this.errorList = res.response.data.errors || [
              res.response.data.exceptionmsg
            ];
          }
        });
      this.uploading = true;
      this.uploading = false;
    }
  }
}
